<template>
    <div class="ModeraFunction container-fluid form-horizontal">
        <button class="btn btn-primary col-sm-12 " v-bind:class="{ disabled: !isGenerateButton,on: isGenerateModelMode }" type="button" v-on:click="isGenerateModelMode=!isGenerateModelMode">Generate Fly Point</button>
        <button class="btn btn-primary col-sm-12" type="button" v-on:click="mergeModel()">Merge Fly Point</button>
        <button class="btn btn-primary col-sm-12" type="button" v-on:click="mergeModel({isWithOrientation:false})">Merge Fly Point WOO</button>
        <!--<button class="btn btn-info col-sm-12" v-bind:class="{ disabled: !isGenerateButton,on: isGenerateViewMode }" type="button" v-on:click="isGenerateViewMode=!isGenerateViewMode">Create a sub View</button>
        <button class="btn btn-primary col-sm-12" type="button" v-on:click="test()">Test function</button>-->
        <div v-show="isShowSubView">
            <div id="subViewDoom">
                <div id="subViewheader" class="title">
                    <strong>SUB VIEW</strong>
                    <span class="exit" v-on:click="close">X</span>
                </div>
                <div id="subAirViewer" class="SubView"></div>
            </div>
            <!--<div id="mydiv">
                <div id="mydivheader">Click here to move</div>
                <p>Move</p>
                <p>this</p>
                <p>DIV</p>
            </div>-->
        </div>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'ModeraFunction',
    data () {
    return {
        msg: 'This is Modera Function save!',
        titleName: 'Save Data',
        isGenerateModelMode: false,
        isGenerateViewMode: false,
        isGenerateButton: true,
        isShowSubView: false,
        subAirViewDoom: {},
        tempModel: "",
        drawFlag: 0
    }
    },
    mounted: function() {
        pfAirViewer._clickEventHelper.add(pfAirViewer.sceneClicked,this.generateModel);
        pfAirViewer._clickEventHelper.add(pfAirViewer.sceneClicked,this.createViewer);
        /*pfAirViewer._drawLayerManager = new Cesium.DataManager({
            id : "draw",
            viewer : pfAirViewer,
            layerData : []
        });*/
        this.dragElement( document.getElementById("subViewDoom") );
        this.subAirViewDoom = document.getElementById("subAirViewer");
        
    },
    methods: {
        generateModel: function(e) {
            if(this.isGenerateModelMode)
            {
                var model = pfAirViewer._modelGenerator.generateModel({
                    e : e,
                    test : pfAirViewer
                });
                pfAirViewer._entitySelector._entities.add(model);
                this.drawFlag++;
                var layerName = "00"+this.drawFlag;
                var drawLayerObject = {};
                drawLayerObject.name = layerName;
                drawLayerObject.type = 'entity';
                drawLayerObject.createdTime = "";
                drawLayerObject.updatedTime = "";
                drawLayerObject.address = "";
                drawLayerObject.cesiumData = model;
                pfAirViewer._drawLayerManager.addLayerData(layerName,drawLayerObject);
                pfAirViewer._drawLayerManager.setLayerDataStatus(layerName,"load");
                pfAirViewer._drawLayerManager.setLayerDataStatus(layerName,"show");
                //pfAirViewer.entities.add(model);
                //pfAirViewer.flyTo(model);
                //var picked = pfAirViewer.scene.pick(e.position);
                var createTime = new Date();
                var testTime = Cesium.JulianDate.now();
                testTime = Cesium.JulianDate.toDate(testTime);
                testTime = testTime.toString();
                createTime = new Date(testTime);
                this.isGenerateModelMode = false;
                eventBus.$emit('addModelPanel',{
                    name: layerName,
                    time: createTime,
                    type: "Fly Point"
                });
                //this.tempModel = model;
            }
        },
        mergeModel: function(options) {
            if(pfAirViewer._drawLayerManager._length)
            {
                var entityCollection = new Cesium.EntityCollection();
                for(var i in pfAirViewer._drawLayerManager._layerData)
                {
                    entityCollection.add(pfAirViewer._drawLayerManager._layerData[i].cesiumData);
                }
                var isWithOrientation = true;
                if( Cesium.defined(options) && Cesium.defined(options.isWithOrientation) ){
                    isWithOrientation = options.isWithOrientation;
                }
                var resaultEntity = Cesium.HomelessFunction.mergeEntityCluster({
                    data: entityCollection,
                    isWithOrientation : isWithOrientation
                });
                pfAirViewer.clock.startTime = resaultEntity.availability.start;
                pfAirViewer.clock.stopTime = resaultEntity.availability.stop;
                pfAirViewer.clock.clockRange = Cesium.ClockRange.LOOP_STOP;

                //remove fly point
                pfAirViewer._drawLayerManager.removeAll();
                eventBus.$emit('removePanel');

                this.drawFlag++;
                var layerName = "00"+this.drawFlag;
                var drawLayerObject = {};
                drawLayerObject.name = layerName;
                drawLayerObject.type = 'entity';
                drawLayerObject.createdTime = "";
                drawLayerObject.updatedTime = "";
                drawLayerObject.address = "";
                drawLayerObject.cesiumData = resaultEntity;
                pfAirViewer._drawLayerManager.addLayerData(layerName,drawLayerObject);
                pfAirViewer._drawLayerManager.setLayerDataStatus(layerName,"load");
                pfAirViewer._drawLayerManager.setLayerDataStatus(layerName,"show");

                eventBus.$emit('addModelPanel',{
                    name: layerName,
                    type: "Fly",
                    startTime: Cesium.JulianDate.toDate(pfAirViewer.clock.startTime),
                    stopTime: Cesium.JulianDate.toDate(pfAirViewer.clock.stopTime)
                });
            }
        },
        renderCameraToCanvas: function(subCanvas,subCamera,Viewer){
            console.log(subCanvas);
            console.log(subCamera);
            console.log(Viewer);
        },
        createViewer: function(e) {
            if(this.isGenerateViewMode)
            {
                 var model = pfAirViewer._modelGenerator.generateModel({
                    e : e,
                    test : pfAirViewer
                });
                pfAirViewer._entitySelector._entities.add(model);
                this.drawFlag++;
                var layerName = "00"+this.drawFlag;
                var drawLayerObject = {};
                drawLayerObject.name = layerName;
                drawLayerObject.type = 'entity';
                drawLayerObject.createdTime = "";
                drawLayerObject.updatedTime = "";
                drawLayerObject.address = "";
                drawLayerObject.cesiumData = model;
                pfAirViewer._drawLayerManager.addLayerData(layerName,drawLayerObject);
                pfAirViewer._drawLayerManager.setLayerDataStatus(layerName,"load");
                pfAirViewer._drawLayerManager.setLayerDataStatus(layerName,"show");
                this.isGenerateViewMode = false;
                this.isShowSubView = true;
                
                eventBus.$emit('addViewPanel',{
                    name: layerName,
                    time: "time",
                    type: "View Point"
                });
                var canvas = document.createElement('canvas');
                this.renderCameraToCanvas(canvas,pfAirViewer.camera,pfAirViewer);
                //var destCtx = canvas.getContext('2d');
                //destCtx.drawImage(pfAirViewer.scene.canvas, 0, 0);
                //canvas = pfAirViewer.scene.canvas;
                //canvas = JSON.parse ( JSON.stringify(pfAirViewer.scene.canvas) );
                //Object.assign(canvas, pfAirViewer.scene.canvas)
                //canvas.width = pfAirViewer.scene.canvas.width;
                //canvas.height = pfAirViewer.scene.canvas.height;
                //var backCtx = backCanvas.getContext('2d');
                this.subAirViewDoom.appendChild(canvas);
            }
        },
        test: function() {
        },
        dragElement: function(elmnt) {
            var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
            if (document.getElementById(elmnt.id + "header")) {
                /* if present, the header is where you move the DIV from:*/
                document.getElementById(elmnt.id + "header").onmousedown = dragMouseDown;
            } else {
                /* otherwise, move the DIV from anywhere inside the DIV:*/
                elmnt.onmousedown = dragMouseDown;
            }

            function dragMouseDown(e) {
                e = e || window.event;
                // get the mouse cursor position at startup:
                pos3 = e.clientX;
                pos4 = e.clientY;
                document.onmouseup = closeDragElement;
                // call a function whenever the cursor moves:
                document.onmousemove = elementDrag;
            }

            function elementDrag(e) {
                e = e || window.event;
                // calculate the new cursor position:
                pos1 = pos3 - e.clientX;
                pos2 = pos4 - e.clientY;
                pos3 = e.clientX;
                pos4 = e.clientY;
                // set the element's new position:
                elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
                elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
            }

            function closeDragElement() {
                /* stop moving when mouse button is released:*/
                document.onmouseup = null;
                document.onmousemove = null;
            }
        },
        close: function(){
            this.isShowSubView = false;
        }
    },
    components: {
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ModeraFunction {
    margin: 5px;
}
.on {
    border:4px solid #f3f30cfa;
    box-shadow: 10px 10px 30px #888888 ;
}
.col-sm-12 {
    margin-bottom: 10px;
}
#subViewDoom {
    position: fixed;
    z-index: 900001;
    border: 1px solid #d3d3d3;
    text-align: center;
    border-radius: 5px;
    height: 50%;
    left: 35%;
    top: 25%;
    width: 30%;
    background: #f3f3f3 none repeat scroll 0 0;
    border: medium none;
    padding: 0;
}
#subViewheader {
    height: 10%;
    
    cursor: move;
    z-index: 900002;
    background-color: #12285f;
    color: #fff;
}
.SubView {
    z-index: 900000;
    height: 90%;
}
.title {
    background-color: #12285f;
    border: medium none;
    border-radius: 3px 3px 0 0;
    clear: both;
    color: #fff;
    height: 44px;
    line-height: 44px;
    overflow: hidden;
}
.title strong {
    display: block;
    font-size: 16px;
    font-weight: normal;
    text-align: center;
    text-transform: uppercase;
}
.title .exit {
    background: rgba(0, 0, 0, 0) url('../../static/Cesium/Assets/AirEarth/images/close_w.png') no-repeat scroll center center;
    border: medium none;
    cursor: pointer;
    display: block;
    height: 40px;
    line-height: 40px;
    position: absolute;
    right: 0;
    text-align: center;
    text-indent: -99999px;
    top: 0;
    width: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/ModeraFunction.vue